import React from "react";
import {UploadFile} from "../../AiThreads/interfaces";
import { FileCsv as IconDocumentExcel, FilePdf as IconDocumentPdf, FileWord as IconDocumentWord } from "flowbite-react-icons/outline";


export const renderFile = (aiFiles: UploadFile[]) => {
  if (!aiFiles || aiFiles.length === 0) return null;
  return (
    <div className="flex flex-wrap gap-2 mt-2">
      {aiFiles.map((aiFile, idx) => {
        if (aiFile.filetype === "image") {
          return (
            <div key={idx} className="mt-4 align-right ml-auto max-w-[67%]">
              <img src={aiFile.bytes} className="rounded-[6px]" alt="img"/>
            </div>
          );
        } else if (aiFile.filetype === "pdf") {
          return (
            <div key={idx} className="mt-4 flex align-right ml-auto rounded-[6px] bg-indigo-900 p-2 items-center">
              <div className="rounded-[4px] bg-indigo-700 p-2">
                <IconDocumentPdf className="h-6 w-6 text-white" aria-hidden="true" />
              </div>
              <div className="ml-2 text-gray-400 z-title4">
                <div className="truncate" style={{width: 150}}>{aiFile.filename}</div>
                <p>PDF</p>
              </div>
            </div>
          );
        } else if (aiFile.filetype === "excel") {
          return (
            <div key={idx} className="mt-4 flex align-right ml-auto rounded-[6px] bg-indigo-900 p-2 items-center">
              <div className="rounded-[4px] bg-indigo-700 p-2">
                <IconDocumentExcel className="h-6 w-6 text-white" aria-hidden="true" />
              </div>
              <div className="ml-2 text-gray-400 z-title4">
                <div className="truncate" style={{width: 150}}>{aiFile.filename}</div>
                <p>Excel</p>
              </div>
            </div>
          );
        } else if (aiFile.filetype === "word") {
          return (
            <div key={idx} className="mt-4 flex align-right ml-auto rounded-[6px] bg-indigo-900 p-2 items-center">
              <div className="rounded-[4px] bg-indigo-700 p-2">
                <IconDocumentWord className="h-6 w-6 text-white" aria-hidden="true" />
              </div>
              <div className="ml-2 text-gray-400 z-title4">
                <div className="truncate" style={{width: 150}}>{aiFile.filename}</div>
                <p>Word</p>
              </div>
            </div>
          );
        }
        return null;
      })}
    </div>
  );
};
